

import React, { memo } from 'react';
import _debounce from 'lodash.debounce';

import { ModuleType } from '../../../types';
import { Image, Title, Text, Divider, Video, ButtonGroup } from './Blocks';



















const ColumnBuilder = ({
  uuid: moduleId,
  rowId,
  columnId,
  type,
  descriptor,
  isEditable,
  isVisible,
  isImageUploader,
  isLinkEditable,
  isResizable,
  showRecipientName,
  onChange,
  canUploadVideoImage,
  hideVisibleOption = false,
  isWorkspaceAdminLinkEditable = true
}) => {
  const onBlockChange = (actionType, data) => {
    const uuids = { moduleId, rowId, columnId };
    onChange(actionType, data, uuids);
  };

  if (type === ModuleType.IMAGE) {
    return (
      <Image
        {...descriptor}
        moduleId={moduleId}
        rowId={rowId}
        columnId={columnId}
        isEditable={isEditable}
        isVisible={isVisible}
        isImageUploader={isImageUploader}
        isLinkEditable={isLinkEditable}
        canUploadVideoImage={canUploadVideoImage}
        handleTemplateChange={_debounce(onBlockChange, 250)}
        isResizable={isResizable}
        hideVisibleOption={hideVisibleOption}
        isWorkspaceAdminLinkEditable={isWorkspaceAdminLinkEditable} />);


  }

  if (type === ModuleType.TITLE) {
    return (
      <Title
        {...descriptor}
        moduleId={moduleId}
        rowId={rowId}
        columnId={columnId}
        isEditable={isEditable}
        isVisible={isVisible}
        showRecipientName={showRecipientName}
        hideVisibleOption={hideVisibleOption}
        handleTemplateChange={_debounce(onBlockChange, 250)} />);


  }

  if (type === ModuleType.TEXT) {
    return (
      <Text
        {...descriptor}
        moduleId={moduleId}
        rowId={rowId}
        columnId={columnId}
        isEditable={isEditable}
        isVisible={isVisible}
        showRecipientName={showRecipientName}
        hideVisibleOption={hideVisibleOption}
        handleTemplateChange={_debounce(onBlockChange, 250)} />);


  }

  if (type === ModuleType.VIDEO) {
    return (
      <Video
        {...descriptor}
        moduleId={moduleId}
        rowId={rowId}
        columnId={columnId}
        isEditable={isEditable}
        isVisible={isVisible}
        canUploadVideoImage={canUploadVideoImage}
        hideVisibleOption={hideVisibleOption}
        handleTemplateChange={_debounce(onBlockChange, 250)} />);


  }

  if (type === ModuleType.DIVIDER) {
    return <Divider {...descriptor} />;
  }

  if (type === ModuleType.BUTTON_GROUP) {
    return (
      <ButtonGroup
        {...descriptor}
        moduleId={moduleId}
        rowId={rowId}
        columnId={columnId}
        handleTemplateChange={_debounce(onBlockChange, 250)} />);


  }

  return null;
};

export default memo(ColumnBuilder);